/**
 * Try to use separate files in /components/
 */

import './components/breakpoint-change';
import './components/header-search-toggle';
import './components/primary-megamenu';
import './components/language-switcher';
import './components/location-modal';
import './components/delay-search-queries';
import './components/inspiration-card-label-tone';
import './components/fancybox';
import './components/footer-menus';
import './components/gravityforms-loader';
import './components/country-popup';
import './components/country-switcher';
import { initDetailsAnimation } from './components/animate-details';

initDetailsAnimation();
